import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import ArtistList from './components/ArtistList.vue';
import ArtistDetails from './components/ArtistDetails.vue';
import Login from './components/Login.vue';
import SongDetails from './components/SongDetails.vue';
import SongEdit from './components/SongEdit.vue';
import About from './views/About.vue';
import {loginRequired} from '@/api/user';

Vue.use(Router);


const router = new Router({

    routes: [
        {
            path: '/login',
            name: 'login',
            component: Login,
        },
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/about',
            name: 'about',
            component: About,
        },
        {
            path: '/artists',
            name: 'artists',
            component: ArtistList,
        },
        {
            path: '/artists/:id',
            name: 'artist',
            component: ArtistDetails,
        },
        {
            path: '/songs/:id/edit',
            name: 'songEdit',
            beforeEnter: loginRequired(),
            component: SongEdit,
        },
        {
            path: '/songs/:id',
            name: 'song',
            component: SongDetails,
        },
    ],

});

export default router;